







































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { weather } from "@/config/host.config";
import StandartModal from "@/components/app/standart-modal.vue";

interface IWeatherMode {
  currentMode: string;
  currentProvider: string;
  currentInterval: number;
  yandex?: {
    apiKey: string;
    oldakey: string;
    limits: string;
    goodInterval: number;
  };
  weatherapi?: { apiKey: string; limits: string; goodInterval: number };
  availableModes: string[];
  availableProviders: string[];
  intervals: Record<string, number>;
}

interface IWeatherInformer {
  temp: number;
  feelsLike: number;
  condition: string;
  humidity: number;
  windSpeed: number;
  windDir: string;
  pressureMm: number;
  obsTime: string;
  now: string;
}

@Component({ name: "weather-configuration", components: { StandartModal } })
class WeatherConfiguration extends Vue {
  form: Partial<IWeatherMode> = {};
  currentMode = "";
  currentProvider = "";
  currentInterval = 0;
  informer: IWeatherInformer | null = null;
  informerLoading = false;
  tabIndex = 0;
  providerDataLocal: Record<string, unknown> = {};

  get modeOptions(): Array<{ value: string; text: string }> {
    const labels: Record<string, string> = {
      gps: this.$t("configuration.weather.modes.gps") as string,
      route: this.$t("configuration.weather.modes.route") as string,
    };
    return (this.form.availableModes || []).map((m) => ({
      value: m,
      text: labels[m] || m,
    }));
  }

  get providerOptions(): Array<{ value: string; text: string }> {
    const labels: Record<string, string> = {
      yandex: "Yandex",
      weatherapi: "WeatherAPI",
    };
    return (this.form.availableProviders || []).map((p) => ({
      value: p,
      text: labels[p] || p,
    }));
  }

  get providerData(): Record<string, unknown> | null {
    if (!this.currentProvider) return null;
    return (
      ((this.form as Record<string, unknown>)[this.currentProvider] as Record<
        string,
        unknown
      >) || null
    );
  }

  get goodIntervalMinutes(): number {
    return Math.round(
      ((this.providerData?.goodInterval as number) || 0) / 60000
    );
  }

  @Watch("currentProvider")
  onProviderChange(): void {
    this.syncProviderData();
  }

  syncProviderData(): void {
    if (this.providerData) {
      this.providerDataLocal = { ...this.providerData };
    } else {
      this.providerDataLocal = {};
    }
  }

  formatTime(ts: string | number): string {
    if (!ts) return "—";
    try {
      const date = typeof ts === "number" ? new Date(ts * 1000) : new Date(ts);
      return date.toLocaleString(this.$i18n.locale);
    } catch {
      return String(ts);
    }
  }

  async updateMode(): Promise<void> {
    try {
      if (this.currentProvider && this.providerDataLocal) {
        (this.form as Record<string, unknown>)[this.currentProvider] = {
          ...this.providerDataLocal,
        };
      }
      const payload: Record<string, unknown> = {
        currentMode: this.currentMode,
        currentProvider: this.currentProvider,
        currentInterval: this.currentInterval,
      };
      if (this.currentProvider) {
        payload[this.currentProvider] = { ...this.providerDataLocal };
      }
      const res = await this.$axios.post(weather.mode, payload);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.$bvModal.hide("weather-config-settings");
        this.fetchSettings();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async fetchSettings(): Promise<void> {
    try {
      const res = await this.$axios.get(weather.mode);
      if (res.status === 200) {
        this.form = res.data;
        this.currentMode = res.data.currentMode || "";
        this.currentProvider = res.data.currentProvider || "";
        this.currentInterval = res.data.currentInterval || 0;
        this.syncProviderData();
      }
    } catch (error) {
      console.log(error);
    }
  }

  async fetchInformer(): Promise<void> {
    this.informerLoading = true;
    try {
      const res = await this.$axios.get(weather.mainApi);
      if (res.status === 200 && res.data) {
        const fact = res.data.fact || {};
        this.informer = {
          temp: fact.temp ?? 0,
          feelsLike: fact.feels_like ?? 0,
          condition: fact.condition ?? "",
          humidity: fact.humidity ?? 0,
          windSpeed: fact.wind_speed ?? 0,
          windDir: fact.wind_dir ?? "",
          pressureMm: fact.pressure_mm ?? 0,
          obsTime: fact.obs_time ?? "",
          now: res.data.now ?? "",
        };
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.informerLoading = false;
    }
  }

  mounted(): void {
    this.fetchSettings();
    this.fetchInformer();
  }
}
export default WeatherConfiguration;
